import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CartRow, OrderRow } from 'gung-standard';

@Injectable({
  providedIn: 'root'
})
export class TyloFreightCostService {
  constructor(private http: HttpClient) {}

  public getFreightCost(deliveryMethodCode: string, fraktkol3limit: number, landskod?: string): Observable<{ value: number }> {
    const urlString = `json/tylo/freight-costs/${deliveryMethodCode}/${fraktkol3limit}`;
    const params = landskod ? new HttpParams().set('landskod', landskod) : undefined;
    return this.http.get<{ value: number }>(urlString, { params });
  }

  public checkIfManualFreightCost(cartRows: CartRow[], customerId: String): Observable<boolean> {
    const orderRows: OrderRow[] = cartRows.map(
      row =>
        ({
          orderId: null,
          rownr: null,
          productId: row.productId,
          quantity: row.qty
        } as OrderRow)
    );
    const urlString = 'json/tylo/check-if-manual-freight' + '?customerId=' + customerId;
    return this.http.post<boolean>(urlString, orderRows);
  }

  public getTemporaryFreightConfigData(): Observable<any> {
    const url = 'json/tylo/get-temporary-freight-config';
    return this.http.get<any>(url);
  }
}
